import { client } from "../../../api/client";

export const fetchSuppliers = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_supplierData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/supplier");
      return response.data;
    } catch (error) {
        console.error("Error fetching suppliers:", error);
        return [];
    }
  }
};

export const updateSupplier = async (supplier) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", supplier: supplier }
    } else {
        try {
          const response = await client.put(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/supplier/" + supplier.id, supplier);
          return response.data;
        } catch (error) {
            console.error("Error creating supplier:", error);
            return { message: "error:" + error, supplier: null }
        }
      }
}

export const deleteSupplier = async (supplierId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", supplier: supplierId }
    } else {
        try {
          const response = await client.delete(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/supplier/" + supplierId);
          return response.data;
        } catch (error) {
            console.error("Error deleting supplier:", error);
            return { message: "error:" + error, supplier: null }
        }
      }
}

export const createSupplier = async (supplier) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", supplier: {
        ...supplier, 
          id: Math.floor(Math.random() * 900) + 101, // gives 101 to 1000
          createdAt: Date.now(),
          updatedAt: Date.now(),
          supplierCategory: null,
          supplier: null,
          supplierRevisions: []
        } }
    } else {
        try {
          const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/supplier", supplier);
          return response.data;
        } catch (error) {
            console.error("Error creating supplier:", error);
            return { message: "error:" + error, supplier: null }
        }
      }
}